var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "py-1"
  }, [_vm.v == undefined ? _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "key-only key value",
    domProps: {
      "innerHTML": _vm._s(_vm.k)
    }
  })]) : _vm.k == undefined ? _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "value-only value",
    class: {
      disabled: _vm.disabled || _vm.disabled === null
    },
    domProps: {
      "innerHTML": _vm._s(_vm.v)
    }
  })]) : _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "key",
    style: {
      width: _vm.width ? _vm.width : undefined
    },
    domProps: {
      "innerHTML": _vm._s(_vm.k)
    }
  }), _c('div', {
    staticClass: "value",
    style: {
      width: _vm.width ? "calc(100% - ".concat(_vm.width, ")") : undefined
    },
    domProps: {
      "innerHTML": _vm._s(_vm.v)
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }